import { ReactElement } from 'react'
import styled from 'styled-components'

import { IIconProps } from './types'

const Svg = styled.svg`
  fill: #423f9a;
  height: 24px;
  width: 24px;
`
export const BookingsIcon = ({ className }: IIconProps): ReactElement => {
  return (
    <Svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.60078 16.4C6.31875 16.4 6.90078 15.8179 6.90078 15.1C6.90078 14.382 6.31875 13.8 5.60078 13.8C4.88281 13.8 4.30078 14.382 4.30078 15.1C4.30078 15.8179 4.88281 16.4 5.60078 16.4Z" />
      <path d="M9.3 12.2C10.018 12.2 10.6 11.6179 10.6 10.9C10.6 10.182 10.018 9.59998 9.3 9.59998C8.58203 9.59998 8 10.182 8 10.9C8 11.6179 8.58203 12.2 9.3 12.2Z" />
      <path d="M13.7004 14.1C14.4184 14.1 15.0004 13.518 15.0004 12.8C15.0004 12.082 14.4184 11.5 13.7004 11.5C12.9824 11.5 12.4004 12.082 12.4004 12.8C12.4004 13.518 12.9824 14.1 13.7004 14.1Z" />
      <path d="M18.4016 10.2C19.1195 10.2 19.7016 9.61795 19.7016 8.89998C19.7016 8.18201 19.1195 7.59998 18.4016 7.59998C17.6836 7.59998 17.1016 8.18201 17.1016 8.89998C17.1016 9.61795 17.6836 10.2 18.4016 10.2Z" />
      <path d="M6.00117 15.4L5.20117 14.7L9.20117 10.2L13.6012 12.3L18.1012 8.5L18.7012 9.3L13.8012 13.5L9.50117 11.5L6.00117 15.4Z" />
    </Svg>
  )
}
